/* ASYCO 2 AI - Autocomplete de busqueda (sugerencias en vivo) para las barras del
   header (desktop .asyco-hsearch__input y mobile .asyco-search__input). Consulta el
   endpoint nativo de Shopify /search/suggest.json. Muestra imagen + titulo (SIN precio:
   el de suggest.json es el de Shopify y puede no coincidir con el CRM; el precio real
   se ve al entrar al producto). Click -> producto; footer -> pagina de resultados. */
(function () {
  'use strict';
  var SEL = '.asyco-hsearch__input, .asyco-search__input';

  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function imgU(u) { if (!u) return ''; if (u.slice(0, 2) === '//') u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96'; }

  function render(dd, prods, q) {
    if (!prods.length) {
      dd.innerHTML = '<div class="asyco-suggest__empty">Sin resultados para “' + esc(q) + '”</div>';
      dd.style.display = 'block'; return;
    }
    var items = prods.map(function (p) {
      var img = (p.featured_image && p.featured_image.url) || p.image || '';
      return '<a class="asyco-suggest__item" href="' + p.url + '">' +
        (img ? '<img class="asyco-suggest__img" loading="lazy" src="' + imgU(img) + '" alt="">' : '<span class="asyco-suggest__img"></span>') +
        '<span class="asyco-suggest__t">' + esc(p.title) + '</span></a>';
    }).join('');
    var all = '<a class="asyco-suggest__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">Ver todos los resultados de “' + esc(q) + '”</a>';
    dd.innerHTML = items + all;
    dd.style.display = 'block';
  }

  function attach(input) {
    if (input.__asycoSuggest) return; input.__asycoSuggest = 1;
    var form = input.closest('form');
    var anchor = (form && form.parentElement) || input.parentElement;
    if (getComputedStyle(anchor).position === 'static') anchor.style.position = 'relative';
    var dd = document.createElement('div');
    dd.className = 'asyco-suggest';
    dd.setAttribute('role', 'listbox');
    dd.style.display = 'none';
    anchor.appendChild(dd);
    var timer;
    function close() { dd.style.display = 'none'; }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) { var prods = (((d.resources || {}).results) || {}).products || []; if (input.value.trim() === q) render(dd, prods, q); })
          .catch(function () {});
      }, 250);
    });
    input.addEventListener('focus', function () { if (dd.innerHTML && input.value.trim().length >= 2) dd.style.display = 'block'; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('click', function (e) { if (!anchor.contains(e.target)) close(); });
  }

  function boot() {
    [].slice.call(document.querySelectorAll(SEL)).forEach(attach);
    // por si alguna barra entra tarde (mobile / re-render): enganchar al primer focus
    document.addEventListener('focusin', function (e) { if (e.target && e.target.matches && e.target.matches(SEL)) attach(e.target); });
    var css = '.asyco-suggest{position:absolute;top:calc(100% + 6px);left:0;right:0;background:#fff;border:1px solid rgba(0,0,0,.12);border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.17);z-index:200;overflow:hidden;max-height:72vh;overflow-y:auto}'
      + '.asyco-suggest__item{display:flex;align-items:center;gap:12px;padding:9px 14px;text-decoration:none;color:#111;border-bottom:1px solid rgba(0,0,0,.05)}'
      + '.asyco-suggest__item:hover{background:#f6f6f6}'
      + '.asyco-suggest__img{width:44px;height:44px;object-fit:contain;flex:0 0 auto;background:#fff;display:block}'
      + '.asyco-suggest__t{font-size:.9rem;line-height:1.25}'
      + '.asyco-suggest__all{display:block;padding:11px 14px;text-align:center;color:#e1242a;font-weight:700;font-size:.88rem;text-decoration:none}'
      + '.asyco-suggest__all:hover{background:#fff5f5}'
      + '.asyco-suggest__empty{padding:14px;text-align:center;color:#888;font-size:.88rem}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
